/*
 * @Author: Jordan
 * @Date: 2019-07-24 19:01:46
 * @Last Modified by: Jordan
 * @Last Modified time: 2020-07-01 01:41:45
 */
import { login, loginOut } from '@/api/interface/user'
const app = {
  state: {
    userInfo: null,
    isMobile: false,
    timeDiff: 0,
    uploadParams: null,
    device: null,
    cityName: null, // 所在城市
    longitude: null, // 用户所在纬度
    latitude: null, // 用户所在经度
    publishStatus: 0,
    operateCode: 'abd4407d-c4ab-11ea-ba14-9c5c8e7be297',
    shareList: {
      indexM: '2025年“文化和自然遗产日”大连非遗系列活动',
      indexF: '精彩内容等你来看！',
      picshowM: '“文化和自然遗产日”宣传展示',
      picshowF:'快来感受文化魅力→',
      marketM:'城市文旅融合市集',
      marketF:'精彩内容等你来看！',
      detail:'',
      imgUrl: require("@/assets/imgwx/dlact2/shareimg.png")
    }
  },

  mutations: {
    SET_PUBLISHOVER: (state, publishStatus) => {
      state.publishStatus = publishStatus
    },
    SET_DEVICE: (state, device) => {
      state.device = device
    },
    SET_POSITION: (state, position) => {
      state.position.latitude = position.latitude
      state.position.longitude = position.longitude
    },
    SET_CITY: (state, cityName) => {
      state.cityName = cityName
    },
    SET_LONGITUDE: (state, longitude) => {
      state.longitude = longitude
    },
    SET_LATITUDE: (state, latitude) => {
      state.latitude = latitude
    },
    SET_MAPDATA: (state, obj) => {
      state.cityName = obj.city
      state.longitude = obj.bounds.northeast.lng
      state.latitude = obj.bounds.northeast.lat
      state.latitude = obj.bounds.northeast.lat
    },
    SET_UPLOADPARAMS: (state, uploadParams) => {
      state.uploadParams = uploadParams
    },
    SET_ISMOBILE: (state, isMobile) => {
      state.isMobile = isMobile
    },
    SET_USERINFO: (state, userinfo) => {
      state.userInfo = userinfo
    },
    SET_SYSTIME: (state, timeDiff) => {
      state.timeDiff = timeDiff
    }
  },
  actions: {
    // 用户登录
    login({ commit }, userInfo) {
      const { userCode, password } = userInfo
      return new Promise((resolve, reject) => {
        login({ userCode: userCode.trim(), password: password }).then(response => {
          const { data } = response
          commit('SET_USERINFO', response.data.data.list[0].user)
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 用户登出
    loginOut({ commit }) {
      return new Promise((resolve, reject) => {
        loginOut().then(res => {
          commit('SET_USERINFO', null)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js